import React, {useContext, useEffect, useState} from 'react'
import axios from "axios";
import AllTripsMap from "./AllTripsMap";
import ViewTrip from "./ViewTrip";
import CreateTrip from "./CreateTrip";
import CircularProgress from '@mui/material/CircularProgress';
import {UserContext} from "./UserContext";
import {getBearerToken, getServerUrl, showTrips} from "./utils/utils";
import Pagination from "@mui/material/Pagination";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import TagFriendsBulkModal from "./TagFriendsBulkModal";
import {confirmAlert} from "react-confirm-alert";
import {useHistory} from "react-router-dom";


function Trips() {
    let history = useHistory();
    const {user, allTrips} = useContext(UserContext)
    const [trips, setTrips] = useState([])
    const [locations, setLocations] = useState([])
    const [totalNumTrips, setTotalNumTrips] = useState(0)
    const [numTrips, setNumTrips] = useState(0)
    const [locationsClickedStatus, setLocationsClickedStatus] = useState({})
    const [openViewTripModal, setOpenViewTripModal] = useState(false)
    const [viewTripId, setViewTripId] = useState(null)
    const [openCreateTripModal, setOpenCreateTripModal] = useState(false)
    const [retrievingTrips, setRetrievingTrips] = useState(false)
    const [fullscreen, setFullscreen] = useState(false)
    const [fullscreenLoading, setFullscreenLoading] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [shouldSearch, setShouldSearch] = useState(false)
    const [searchedTrips, setSearchedTrips] = useState([])
    const [startPictureSlideshow, setStartPictureSlideshow] = useState(false)
    const [openTagFriendsModal, setOpenTagFriendsModal] = useState(false)
    const [secondAlert, setSecondAlert] = useState(false)

    useEffect(() => {
        if (user?.id && allTrips?.length > 0) {
            retrieveTrips(0)
            setRetrievingTrips(true)
        }
    }, [user, allTrips]);


    useEffect(() => {
        if (shouldSearch) {
            searchForTrips(searchValue)
            setShouldSearch(false)
        }
    }, [shouldSearch, searchValue])

    useEffect(() => {
        if (allTrips?.length > 0) {
            window.scrollTo(0, 0);
            setNumTrips(allTrips.length)
            setTotalNumTrips(allTrips.length)
            setLocations(allTrips.map(trip => trip.location))
        }
    }, [allTrips])

    const searchForTrips = async(searchValue) => {
        let updatedSearchValue = searchValue
        if (searchValue.includes(" (")) {
            updatedSearchValue = searchValue.split(" (")[0]
        }
        updatedSearchValue = updatedSearchValue.replace("/", "***")
        axios.get(`${getServerUrl()}/trips/${updatedSearchValue}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setSearchedTrips(response.data)
                setNumTrips(response.data.length)
            })
    }

    const getPageTripIds = (index) => allTrips.sort((a,b) => new Date(b.startDate) - new Date(a.startDate))
        .slice(index * 12, allTrips.length <  index * 12 + 12 ? allTrips.length : index * 12 + 12)
        .map(trip => trip.id)

    const  retrieveTrips = async (index) => {
        const pageTripIds = getPageTripIds(index)
        axios.post(`${getServerUrl()}/trip/ids`, pageTripIds, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`,
            }
        }).then(response => {
            setTrips(response.data.sort((a,b) => new Date(b.startDate) - new Date(a.startDate)))
            setRetrievingTrips(false)
            if (numTrips < allTrips.length) {
                setNumTrips(allTrips.length)
            }
        });
    }

    const retrieveTripsByLocation = async (location) => {
        const cityName = location.split(",")[0].toLowerCase();
        axios.get(`${getServerUrl()}/user/${user?.id}/trip/location/${cityName}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setNumTrips(response.data.numTrips)
                setTrips(response.data.trips);
                setSearchedTrips([])
            })
    }

    const filterTripsForMarkerEvent = (tripLocation, locationMarkersObj) => {
        setLocationsClickedStatus(obj => {
            const updatedTripLocationsObj = {...obj}
            Object.keys(updatedTripLocationsObj).forEach(location => {
                if (tripLocation !== location)
                    updatedTripLocationsObj[location] = false
            })
            const viewingTripsForLocation = !updatedTripLocationsObj[tripLocation]
            updatedTripLocationsObj[tripLocation] = viewingTripsForLocation
            if (viewingTripsForLocation) {
                retrieveTripsByLocation(tripLocation)
            } else {
                retrieveTrips(0)
            }
            setTrips([])
            return updatedTripLocationsObj
        })
    }

    const markerSelected = () => {
        let numSelected = 0;
        Object.keys(locationsClickedStatus).forEach(location => {
            if (locationsClickedStatus[location]) {
                numSelected++
            }
        })
        return numSelected > 0
    }

    const onTripSelect = trip => {
        setViewTripId(trip.id)
        setOpenViewTripModal(true)
    }

    return (
        <div style={openViewTripModal ? {position: "fixed"} : {position: "relative"}} className="all-trips-container">
            {!fullscreen && (
                <>
                    <button className="ui button" id="create-trip-button" type="button"
                            onClick={() => setOpenCreateTripModal(true)}>Create Trip
                    </button>
                    {allTrips.length > 0 && (
                        <button className="ui button" id="tag-friends-button" type="button"
                                onClick={() => setOpenTagFriendsModal(true)}>Tag Friends
                        </button>
                    )}
                </>
            )}
            <button
                className="ui button"
                id="full-screen-button"
                type='button'
                onClick={() => {
                    setFullscreen(!fullscreen)
                    setFullscreenLoading(true)
                    setTimeout(() => {
                        setFullscreenLoading(false)
                    }, [500])
                    if (fullscreen && startPictureSlideshow) {
                        setStartPictureSlideshow(false)
                    }
                }}
            >
                {fullscreen ? 'Exit' : 'Fullscreen'}
            </button>
            {!fullscreen && (
                <button
                    className="ui button"
                    id="trips-page-slideshow-button"
                    type='button'
                    onClick={() => {
                        setFullscreen(true)
                        setFullscreenLoading(true)
                        setTimeout(() => {
                            setFullscreenLoading(false)
                            setStartPictureSlideshow(true)
                        }, [500])
                    }}
                >
                    Start Slideshow
                </button>
            )}
            {
                !fullscreenLoading && (
                    <AllTripsMap
                        initialZoomLevel={2}
                        locations={locations ? locations : []}
                        onMarkerEvent={filterTripsForMarkerEvent}
                        locationsClickedStatus={locationsClickedStatus}
                        includeZoom={true}
                        onTripsPage={true}
                        retrievingLocations={retrievingTrips}
                        viewingMultipleTrips={true}
                        fullscreen={fullscreen}
                        trips={trips}
                        startPictureSlideShow={startPictureSlideshow}
                    />
                )
            }
            {(!trips || fullscreenLoading) && (
                <div className="spinner-container">
                    <CircularProgress/>
                </div>
            )}
            {!fullscreen && (
                <>
                    <div className="pagination-container">
                        <div className="ranking-modal-info-container">
                            <Autocomplete
                                id="free-solo-demo"
                                freeSolo
                                options={allTrips?.map((trip) => `${trip.name} (${trip.location})`)}
                                renderInput={(params) => <TextField {...params}
                                                                    label="Search for trips from your trip's by their name, location or year..."/>}
                                onInputChange={(event, newInputValue) => {
                                    setSearchValue(newInputValue)
                                    if (allTrips?.filter(trip => newInputValue.includes(trip.name))?.length > 0 ) {
                                        setShouldSearch(true)
                                    }
                                    if (!newInputValue) {
                                        setSearchedTrips([])
                                        setNumTrips(totalNumTrips)
                                    }
                                }}
                                inputValue={searchValue}
                            />
                            <Button variant="contained" onClick={() => setShouldSearch(true)}>Search</Button>
                        </div>
                        <Pagination count={numTrips ? Math.ceil(numTrips / 12) : 0} color="primary"
                                    onChange={(e, page) => {
                                        retrieveTrips(page - 1)
                                    }}/>
                    </div>
                    <div id="trip-list" style={{position: "relative"}}>
                        {showTrips(searchedTrips?.length > 0 ? searchedTrips : trips, onTripSelect)}
                    </div>
                </>
            )}
            <ViewTrip
                startEditingTrip={false}
                open={openViewTripModal}
                selectedTripId={viewTripId}
                onClose={(updatedTrip, deleteTripBoolean) => {
                    setLocations([])
                    setOpenViewTripModal(false)
                    setViewTripId(null)
                    setLocationsClickedStatus({})
                    if (updatedTrip && deleteTripBoolean) {
                        let numDeletedTripLocation = 0
                        trips.forEach(trip => {
                            if (updatedTrip.location === trip.location) {
                                numDeletedTripLocation++
                            }
                        })
                        if (numDeletedTripLocation === 1) {
                            setLocations(locations.filter(location => location !== updatedTrip.location))
                        }
                        setTrips(trips.filter(trip => trip.id !== updatedTrip.id))
                    } else if (updatedTrip && !deleteTripBoolean) {
                        const updatedTrips = trips.map(trip => {
                            const tripCopy = {...trip}
                            if (trip.id === updatedTrip.id) {
                                tripCopy.trip_profile_image = updatedTrip.profilePicture
                                tripCopy.profileImageId = updatedTrip.profilePictureId
                            }
                            return tripCopy
                        })
                        setTrips(updatedTrips)
                        const updatedSearchedTrips = searchedTrips.map(trip => {
                            const tripCopy = {...trip}
                            if (trip.id === updatedTrip.id) {
                                tripCopy.trip_profile_image = updatedTrip.profilePicture
                                tripCopy.profileImageId = updatedTrip.profilePictureId
                            }
                            return tripCopy
                        })
                        setSearchedTrips(updatedSearchedTrips)
                    }
                }}
                onTripUpdate={updatedTrip => {
                    setOpenViewTripModal(false)
                    setViewTripId(null)
                    setTrips(trips.map(trip => {
                        if (trip.id === updatedTrip.id) {
                            return updatedTrip
                        }
                        return trip
                    }))
                }}
            />
            <CreateTrip open={openCreateTripModal} locations={locations ? locations : []} onClose={newTrip => {
                setOpenCreateTripModal(false)
                if (newTrip) {
                    setTrips([newTrip, ...trips])
                    setLocations([...locations, newTrip.location])
                    setViewTripId(newTrip.id)
                    setOpenViewTripModal(true)
                }
            }}/>
            {allTrips.length > 0 && (
                <TagFriendsBulkModal trips={allTrips} open={openTagFriendsModal}
                                     onClose={() => setOpenTagFriendsModal(false)}/>
            )}
        </div>
    )
}

export default Trips;